import { clsx } from 'clsx';
import { FunctionComponent } from 'react';
import { EntityDisplayConfig } from '../../../interfaces/entity-display-config';
import { ENTITY_DISPLAY_DETAILS_POPPER_DATA_IDS } from './dataIds';
import { EntityDisplayConfigLabel } from '../EntityDisplayConfigLabel/EntityDisplayConfigLabel';
import { EntityDisplayConfigValue } from '../EntityDisplayConfigValue/EntityDisplayConfigValue';
import { Tooltip } from '../../../../tooltip/Tooltip';
import { EntityType } from '../../EntityType/EntityType';
import { HevoIconProps, Icon } from '../../../../icon/Icon';
import styles from './EntityDisplayConfigPopper.module.scss';

interface EntityDisplayDetailsPopperProps {
  entityDisplayConfig?: EntityDisplayConfig;
  logo: string;
  logoDarkMode: string;
  title: string;
}

export function EntityDisplayConfigPopper({
  entityDisplayConfig,
  logo,
  logoDarkMode,
  title
}: EntityDisplayDetailsPopperProps) {
  return (
    <EntityType
      logoSize={1}
      logo={logo}
      logoDarkMode={logoDarkMode}
      title={title}
      className={styles.entityTypeWrapper}
      titleClassName={clsx(styles.entityTitle, 'text-secondary text-medium')}
      extraProps={{
        className: 'ml-2',
        entityDisplayConfig
      }}
      Extra={PreviewTrigger as FunctionComponent<object>}
    />
  );
}

function PreviewTrigger({
  entityDisplayConfig,
  ...iconProps
}: Partial<HevoIconProps> & Pick<EntityDisplayDetailsPopperProps, 'entityDisplayConfig'>) {
  return (
    <Tooltip
      dataId='preview'
      mode='surface'
      disabled={!entityDisplayConfig}
      disableInteractive={false}
      maxWidth='300px'
      maxHeight='300px'
      minHeight='240px'
      title={<ConfigPopperContent entityDisplayConfig={entityDisplayConfig} />}
    >
      <Icon name='view-password' {...iconProps} />
    </Tooltip>
  );
}

function ConfigPopperContent({
  entityDisplayConfig
}: Pick<EntityDisplayDetailsPopperProps, 'entityDisplayConfig'>) {
  return (
    <div className='bg-surface'>
      <div className='center-flex-row w-100 border-bottom px-1 py-1'>
        <span
          className={clsx(
            'text-uppercase text-medium text-secondary',
            styles.entityDisplayDetailsPopperListItemConfig
          )}
        >
          Configuration
        </span>

        <span
          className={clsx(
            'text-uppercase text-medium text-secondary',
            styles.entityDisplayDetailsPopperListItemValue
          )}
        >
          Value
        </span>
      </div>

      <div
        className={clsx('flex-col', styles.entityDisplayDetailsPopperList)}
        data-id={ENTITY_DISPLAY_DETAILS_POPPER_DATA_IDS.details}
      >
        {(entityDisplayConfig || { fields: [] }).fields.map(field => (
          <div
            className={clsx(
              'center-flex-row px-1 w-100',
              styles.entityDisplayDetailsPopperListItem
            )}
            key={field.name}
          >
            <EntityDisplayConfigLabel field={field} containerClassName='w-50' />
            <EntityDisplayConfigValue
              field={field}
              containerClassName='w-50'
              showHelperText={false}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
